import React from 'react';

import { DragOverlay } from '@dnd-kit/core';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { components, GroupBase, MultiValueProps } from 'react-select-5';

export const SortableMultiValue = function <Option, IsMulti extends boolean, Group extends GroupBase<Option>>(
  props: MultiValueProps<Option, IsMulti, Group>,
) {
  const { attributes, listeners, setNodeRef, transform, transition, active, isDragging } = useSortable({
    id: props.selectProps.getOptionValue(props.data),
  });

  const isActive = active?.id === props.selectProps.getOptionValue(props.data);

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    cursor: 'grab',
    opacity: isDragging ? 0.35 : 1,
    maxWidth: '40%',
  };

  return (
    <React.Fragment>
      <div ref={setNodeRef} style={style} {...listeners} {...attributes}>
        <components.MultiValue {...props} />
      </div>

      {isActive && (
        <DragOverlay>
          <components.MultiValue {...props} />
        </DragOverlay>
      )}
    </React.Fragment>
  );
};
